import React from 'react'
import { AnswerItem } from './AnswerItem'
import AnswerList from './AnswerList'

export interface Answers {
  items: AnswerItem[]
  value: string[]
  type: number
  onClick: (value: string[]) => void
  submit: (value: string) => void
  hasAnswerButton?: boolean
  benefitAppealPattern?: string
  row: number
}

const Answers: React.FC<Answers> = (props) => {
  const isRadio = props.type === 1 //Radio
  const isCheckbox = props.type === 2 // Checkbox

  return (
    isRadio || isCheckbox ? <AnswerList {...props} /> : <></>
  )
}

export default Answers
